/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import app from 'flarum/forum/app';
import { slug } from '../common';
import UserGamificationInfos from './components/UserGamificationInfos';
export default function () {
  extend(UserCard.prototype, 'infoItems', function (items) {
    if (app.forum.attribute(`${slug}.gamification.enabled`)) {
      // -100 is the user bio, so -99 places this just above it.
      items.add('gamification', m(UserGamificationInfos, {
        user: this.attrs.user
      }), -99);
    }
  });
}